const GAP = 12;
const MARGIN = 12;

export interface CardSize {
  width: number;
  height: number;
}

/**
 * Where a card goes for a highlighted element: 12 px below it, horizontally
 * centred, clamped 12 px from the viewport edges, flipped above when it would
 * not fit below. Shared by the tour (and later the inspector) so they never
 * disagree.
 */
export function cardPosition(
  rect: { top: number; bottom: number; left: number; width: number },
  size: CardSize,
  viewport: { width: number; height: number } = {
    width: window.innerWidth,
    height: window.innerHeight,
  }
): { top: number; left: number } {
  const maxLeft = Math.max(MARGIN, viewport.width - size.width - MARGIN);
  const left = Math.min(
    Math.max(rect.left + rect.width / 2 - size.width / 2, MARGIN),
    maxLeft
  );

  const below = rect.bottom + GAP;
  const above = rect.top - GAP - size.height;
  let top: number;
  if (below + size.height <= viewport.height - MARGIN) top = below;
  else if (above >= MARGIN) top = above;
  else top = Math.max(MARGIN, viewport.height - size.height - MARGIN);

  return { top, left };
}
